jQuery(document).ready(function($){

$('.collapsible-content').each(function() {
  // Trim the content inside
  if ($.trim($(this).text()) === '') {
    $(this).parent().addClass('hidden');
  }
});



})
